
export function getVevoStream(asset) {
  return Promise.resolve(asset);
}

export const getVEVOAdCategory = () => 'vevo_pluto_zype_linear';

export const parsedAssetsFromVevo = assets => assets;

